import {
  FormCheckbox,
  FormInput,
  Heading,
} from "@/components";
import {
  Button
} from "@/components/ui";
import { FormProvider } from "react-hook-form";
import {
  DOCUMENT_NO,
  HIDE_ZERO_BALANCES,
  INCLUDE_PERIOD_0,
  SHOW_LONG_DESCRIPTION
} from "./consts";
import useDisplayAccountingDocument from "./useDisplayAccountingDocument";
import { DocumentLineItemDialog } from "@/pages/Common";

const DisplayAccountingDocument = () => {
  const {
    breadcrumbData,
    form,
    requiredFields,
    onSubmit,
    selectedDoc,
    currentFinanceYear,
    isRunClicked
  } = useDisplayAccountingDocument();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      <div className="mb-6 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={
              <span>
                Display Accounting Document{" "}
                <span className="text-[12px]">(FY-{currentFinanceYear})</span>
              </span>
            }
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="mb-[30px] mt-[20px] rounded-lg bg-white px-[30px] py-[25px] shadow-md">
            <div className="grid grid-cols-1 items-start gap-[20px] md:grid-cols-2 lg:grid-cols-12">
              <div className="lg:col-span-3">
                <FormInput
                  name={DOCUMENT_NO}
                  control={form.control}
                  label="Document No"
                  placeholder="Please enter"
                  isRequired={requiredFields.includes(DOCUMENT_NO)}
                  error={errors?.[DOCUMENT_NO]?.message as string}
                />
              </div>

              <div className="lg:col-span-9">
                <div className="mb-1 text-[12px] text-gray-600">Options</div>

                <div className="flex flex-wrap items-center gap-6">
                  <FormCheckbox
                    name={INCLUDE_PERIOD_0}
                    label="Include Period 0(Carry forward)"
                    control={form.control}
                  />

                  <FormCheckbox
                    name={HIDE_ZERO_BALANCES}
                    label="Hide Zero Balances"
                    control={form.control}
                  />

                  <FormCheckbox
                    name={SHOW_LONG_DESCRIPTION}
                    label="Show Long Description"
                    control={form.control}
                  />
                </div>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <Button type="submit">Run Report</Button>
            </div>
          </div>
        </form>
      </FormProvider>

      {isRunClicked ? (
        <DocumentLineItemDialog dialog={false} selectedDoc={selectedDoc} showDownloadGLExcel showNoDataOnError />
      ) : null}
    </div>
  );
};

export default DisplayAccountingDocument;
